import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const defaultNS = 'common';

i18n.use(HttpBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: process.env.NODE_ENV === 'development',
		defaultNS,
		ns: [defaultNS],
		supportedLngs: ['en', 'es'],
		fallbackLng: false,

		interpolation: {
			escapeValue: false, // not needed for react
		},

		react: {
			defaultTransParent: 'div', // needed for preact
			useSuspense: true,
		},

		backend: {
			loadPath: `${APP_SETTINGS.publicUrl}i18n/{{lng}}/{{ns}}.json`,
		},
	});

export { i18n };
